// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Adasl","rotation":"Loader_rotation__9omd7"};